<template>
  <div class="EnterpriseData">
    <DetailsHead img="./img/bj4.png" title="企业信息" remarks="Enterprise Data" />
    <TopBreadcrumb :data="[{ label: '产业链情况' }, { label: '企业信息' }]" />
    <div class="con" v-loading="loading">
      <div class="left">
        <div style="display:flex;align-items: center;gap:10px;padding-bottom:10px;">
          <!-- <el-input size="medium" v-model="form.title" placeholder="标题" style="width:250px;" clearable></el-input> -->
          <el-input size="medium" v-model="form.name" placeholder="企业名称" style="width:250px;" clearable></el-input>
          <el-select size="medium" v-model="form.city" placeholder="请选择所在城市" style="width:150px;" clearable>
            <el-option v-for="item in cityList" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <el-input size="medium" v-model="form.creditCode" placeholder="统一社会信用代码 " style="width:250px;" clearable>
          </el-input>

          <el-button size="medium" type="primary" @click="() => { page = 1; select() }">搜索</el-button>
        </div>
        <el-table :data="list" style="width: 100%" :fit="true" highlight-current-row @row-click="handleCurrentChange">
          <!-- <el-table-column prop="" label="" width="20px">
            <template slot-scope="scope">
              <el-radio :value="changeRow.id" :label="scope.row.id"> </el-radio>
            </template>
          </el-table-column> -->
          <el-table-column prop="name" label="企业名称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="city" label="所在市" width="90px">
          </el-table-column>
          <el-table-column prop="creditCode" label="统一社会信用代码" width="195px" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="registeredCapital" label="注册资本" width="107px" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="establishmentDate" label="注册时间" width="130px">
            <template slot-scope="scope">
              <span>{{ new Date(scope.row.establishmentDate).formatCode('YYYY-MM-DD') }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination background layout="prev, pager, next" @current-change="select(false)" :total="total"
            :page-size="size" :current-page.sync="page">
          </el-pagination>
        </div>
      </div>
      <div class="right">
        <!-- <el-select v-show="!isMap" style="width: 100%;" @change="isMap = false" v-model="selectImg" placeholder="请选择">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select> -->
        <!-- <el-button style="width: 100%;margin-bottom: 5px;" v-show="isMap" @click="isMap = false">分布图</el-button> -->
        <!--  :class="{ 'is-none': !isMap }" -->
        <div class="map-box">
          <div id="map"></div>
        </div>
        <!-- <div class="img-box" v-show="!isMap" style="width: 100%;position: relative;">
          <img class="figure-img" :src="selectImg" alt="">
          <img :src="'./img/LndustrialMap/滑块.png'" class="description" alt="">
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import DetailsHead from "../../components/DetailsHead.vue";
import TopBreadcrumb from "../../components/TopBreadcrumb.vue";
import { pageQueryDirectories as pageQuery } from "@/api/industrialMap.js";
import { cityList } from "@/utils";
export default {
  components: { DetailsHead, TopBreadcrumb },
  data() {
    return {
      cityList,
      loading: false,
      list: [],
      map: null,
      form: {},

      changeRow: {}, // 选中的行

      total: 1,
      page: 1,
      size: 12,

      list: [],

      isMap: false,

      selectImg: './img/LndustrialMap/分布总图.png',
      options: [
        {
          value: './img/LndustrialMap/分布总图.png',
          label: '广州规划设计企业分布总图'
        }, {
          value: './img/LndustrialMap/工程设计.png',
          label: '广州规划设计企业（工程设计）分布图'
        }, {
          value: './img/LndustrialMap/工程勘察.png',
          label: '广州规划设计企业（工程勘察）分布图'
        }, {
          value: './img/LndustrialMap/工程监理.png',
          label: '广州规划设计企业（工程监理）分布图'
        }, {
          value: './img/LndustrialMap/城乡规划.png',
          label: '广州规划设计企业（城乡规划）分布图'
        },
      ]
    };
  },
  mounted() {
    this.select();
    this.map = new T.Map("map");
    this.map.centerAndZoom(new T.LngLat(113.27893, 23.1396), 10);


  },
  methods: {
    addOverlay(item) {
      if (!item.location) return;
      let t = item.location.split(",");
      if (t.length != 2) return;
      this.map.setViewport([new T.LngLat(t[0], t[1])]);
      //   this.map.centerAndZoom(new T.LngLat(t[0], t[1]), 16);
      //创建标注对象
      var marker = new T.Marker(new T.LngLat(t[0], t[1]));
      //向地图上添加标注
      this.map.addOverLay(marker);
      //注册标注点的点击事件

      let winHtml = "企业名称：" + item.name;
      var markerInfoWin = new T.InfoWindow(winHtml, { autoPan: true });
      marker.addEventListener("click", function () {
        marker.openInfoWindow(markerInfoWin);
      });
    },
    select() {
      this.loading = true;
      pageQuery({
        page: this.page,
        size: this.size,
        ...this.form,
      })
        .then((res) => {
          const { data } = res;
          this.total = data.total;
          this.list = data.records;

          // this.isMap = false
          // 加载所有的位置
          //坐标数组，设置最佳比例尺时会用到
          var zoomArr = [];
          this.map.clearOverLays(); // 先清空
          this.list.forEach((item) => {
            if (!item.location) return;
            let t = item.location.split(",");
            if (t.length != 2) return;
            var lnglat = new T.LngLat(t[0], t[1]);
            //创建标注对象
            var marker = new T.Marker(lnglat);
            //地图上添加标注点
            this.map.addOverLay(marker);
            //注册标注点的点击事件
            let winHtml = "企业名称：" + item.name;
            var markerInfoWin = new T.InfoWindow(winHtml, { autoPan: true });
            marker.addEventListener("click", function () {
              marker.openInfoWindow(markerInfoWin);
            });
            zoomArr.push(lnglat);
          });
          //显示地图的最佳级别
          this.map.setViewport(zoomArr);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      // return
      this.changeRow = val;
      if (!val.location || val.location.split(",").length != 2) {
        this.$message("位置信息为空");
        return;
      }
      // this.isMap = true
      setTimeout(() => {
        // this.map.clearOverLays();
        // this.addOverlay(val);
        if (!val.location) return;
        let t = val.location.split(",");
        if (t.length != 2) return;
        this.map.setViewport([new T.LngLat(t[0], t[1])]);
      }, 100)
    },
  },
};
</script>
<style lang="less" scoped>
.con {
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 50px;
  width: 1500px;
  display: flex;
  gap: 10px;

}

.left {
  width: 65%;

  .pagination {
    padding: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.right {
  flex: 1;
  //   width: 40%;
  position: relative;
  overflow: hidden;

  .map-box {
    width: 100%;
    height: 700px;
    position: relative;

    &.is-none {
      opacity: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -11;
      pointer-events: none;
    }
  }

  #map {
    width: 100%;
    height: 100%;
    background-color: #fff;

  }

  .img-box {

    .figure-img {
      width: 100%;
      margin-top: 5px;
    }

    .description {
      position: absolute;
      bottom: 30px;
      left: 30px;
      width: 50%;
    }
  }

}
</style>

<style lang="less">
.EnterpriseData {

  .el-table__header,
  .el-table__body,
  .el-table__empty-block {
    width: 100% !important;
  }

  .has-gutter>tr,
  .has-gutter>tr .el-table__cell {
    background-color: rgba(84, 116, 248, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 20px;
  }
}
</style>
